import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { CrossButton } from "@sportal/cdk/crossButton/CrossButton";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";

import { useIntlTranslate } from "../../../../../hooks";
import { ModalDialog, ModalService } from "../../../../../components/modal";
import { Counter } from "../../../../../components/counter/Counter";
import ButtonLink from "../../../../../components/buttonLink/ButtonLink";
import { Icon } from "../../../../../components/icon/Icon";
import { ScheduleCreateDialog } from "../scheduleCreateDialog/scheduleCreateDialog";
import { SCHEDULE_LIMIT } from "../schedules.selectors";
import { ScheduleRule } from "../scheduleRule/ScheduleRule";
import { ScheduleRuleHint } from "../scheduleRuleHint/ScheduleRuleHint";
import { MODAL_WINDOW_TITLE_ID } from "@sportal/cdk/modal/Modal";

import "./scheduleRulesOverlay.scss";

export const ScheduleRulesOverlay = (props) => {
  const translate = useIntlTranslate();

  const [schedules, setSchedules] = useState(() => props.schedules);
  const { type, removeSchedule, changeSchedules, modal } = props;

  const closeOverlay = () => {
    changeSchedules(schedules);
    return modal.reject();
  };

  return (
    <ModalDialog
      rejectHandler={closeOverlay}
      className={"schedule-rules-overlay"}
    >
      <ModalDialog.Header>
        <div className={"schedule-rules-overlay__title"}>
          <div>
            <h2 id={MODAL_WINDOW_TITLE_ID}>
              <FormattedMessage id={`${type}_rules`} />
            </h2>
          </div>
        </div>
        <CrossButton
          className="modal__header__cross-button"
          size="large"
          weight="regular"
          onClick={closeOverlay}
          aria-label={translate("aria_close_dialog")}
        />
      </ModalDialog.Header>
      <ModalDialog.Body>
        <Counter
          className="schedule-rules-overlay__counter"
          label={
            <h2>
              <FormattedMessage id={"rules"} />
            </h2>
          }
          amount={schedules.length}
          limit={SCHEDULE_LIMIT}
        />
        {_.map(schedules, (schedule, key) => (
          <div className={"rule"} key={key}>
            <ScheduleRule
              timeStart={schedule.timeStart}
              timeEnd={schedule.timeEnd}
              selectedDays={schedule.day}
              useShortNotations={true}
            />
            <div className={"rule__actions"}>
              <UnstyledButton
                className="edit-schedule rule__actions__button "
                onClick={() => openEditModal(schedule, schedules, props)}
                aria-label={translate("aria_edit_rule")}
              >
                <Icon icon="fa-regular fa-pencil" />
              </UnstyledButton>
              {schedules.length > 1 && (
                <ButtonLink
                  className="remove-schedule rule__actions__button"
                  onClick={() => {
                    setSchedules((prevSchedules) => {
                      return _.reject(prevSchedules, {
                        id: schedule.id,
                      });
                    });
                    removeSchedule(schedule.id);
                  }}
                  aria-label={translate("aria_delete_rule")}
                >
                  <Icon icon="fa-regular fa-trash" />
                </ButtonLink>
              )}
            </div>
          </div>
        ))}
        {schedules.length === 1 && <ScheduleRuleHint />}
      </ModalDialog.Body>
    </ModalDialog>
  );
};

const openEditModal = (schedule, schedules, props) =>
  ModalService.show((modal) => ({
    dialog: (
      <ScheduleCreateDialog
        {...props}
        {...schedule}
        isEdit={true}
        modal={modal}
        schedules={schedules}
      />
    ),
  }));
